import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { Menu, X, Video, CalendarHeart } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { to: "/services", label: "Services" },
  { to: "/about", label: "Dr. Anuj Shah" },
  { to: "/fun-zone", label: "Fun Zone" },
  { to: "/ask", label: "Ask Sparkle" },
  { to: "/blog", label: "Tips" },
  { to: "/reviews", label: "Reviews" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

const NavLinks = ({ onClick }) => LINKS.map((l) => (
  <NavLink key={l.label} to={l.to} onClick={onClick} data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
    className={({ isActive }) => `whitespace-nowrap rounded-full px-2.5 py-2 text-sm font-semibold transition-colors hover:bg-teal-50 hover:text-teal-700 ${isActive ? "bg-teal-50 text-teal-700" : "text-slate-600"}`}>
    {l.label}
  </NavLink>
));

const Actions = ({ onClick }) => (
  <>
    <Link to="/book?type=online" onClick={onClick} data-testid="nav-online-consult-button"
      className="btn-pop inline-flex items-center gap-2 rounded-full border-2 border-teal-600 px-4 py-2 text-sm font-bold text-teal-700 hover:bg-teal-50">
      <Video className="h-4 w-4" /> Online Consult
    </Link>
    <Link to="/book" onClick={onClick} data-testid="nav-book-appointment-button"
      className="btn-pop shadow-chunky-coral inline-flex items-center gap-2 rounded-full bg-[#ff6b6b] px-5 py-2.5 text-sm font-bold text-white">
      <CalendarHeart className="h-4 w-4" /> Book Visit
    </Link>
    <Link to="/my-appointments" onClick={onClick} data-testid="nav-my-appointments-link"
      className="text-sm font-semibold text-slate-600 hover:text-teal-700">My visits</Link>
    <Show when="signed-in">
      <UserButton />
    </Show>
    <Show when="signed-out">
      <Link to="/sign-in" onClick={onClick} data-testid="nav-sign-in-link" className="text-sm font-semibold text-slate-600 hover:text-teal-700">Sign in</Link>
    </Show>
  </>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-teal-100 bg-white/80 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex max-w-[1600px] items-center justify-between gap-6 px-5 py-3 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-0.5 2xl:flex"><NavLinks /></nav>
        <div className="hidden shrink-0 items-center gap-3 whitespace-nowrap lg:flex"><Actions /></div>
        <button className="rounded-full p-2 text-slate-700 hover:bg-teal-50 2xl:hidden" onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="flex flex-col gap-2 border-t border-teal-100 bg-white px-5 py-4 2xl:hidden" data-testid="mobile-menu">
          <NavLinks onClick={() => setOpen(false)} />
          <div className="mt-2 flex flex-wrap items-center gap-3 lg:hidden"><Actions onClick={() => setOpen(false)} /></div>
        </div>
      )}
    </header>
  );
};
